import { ReportesPrestadoresService } from './reportes-prestadores.service';
import { AuthService } from './../../../../../../../shared/services/auth.service';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { HttpEventType } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';

@Component({
	// tslint:disable-next-line:indent
	selector: 'app-reportes-prestadores',
	// tslint:disable-next-line:indent
	templateUrl: './reportes-prestadores.component.html',
	// tslint:disable-next-line:indent
	styleUrls: ['./reportes-prestadores.component.scss']
})
export class ReportesPrestadoresComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerTabla: Array<string>;
	formUsuario: FormGroup;
	selectUsuario: any;
	camarasLista: Array<CamaraComercioEntry>;
	paginaActual: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	prestador = RolesUsuario.Prestador;
	adminCC = RolesUsuario.AdministradorCC;
	columnas: Array<any> = [];
	columnasEnvio: any;
	// filtros
	filtro: FormGroup;
	formCheck: FormGroup;
	public isCollapsed = true;
	isExportar = true;
	camaraComercio: string;
	// Selects
	categoria: Array<any> = [];
	subcategoria: Array<any> = [];
	estadoRnt: Array<any> = [];
	tipoRNT: Array<any> = [];
	exportarForm: FormGroup;
	exportarList = [
		{ id: 'Descripcion_Camara', name: 'Cámara de Comercio' },
		{ id: 'Razon_Social', name: 'Nombre o razón social' },
		{ id: 'Numero_Identificacion', name: 'Nit' },
		{ id: 'Descripcion_Departamento', name: 'Departamento' },
		{ id: 'Descripcion_Municipio', name: 'Municipio' },
		{ id: 'Usuario', name: 'Usuario' },
		{ id: 'Activo', name: 'Activo' },
		{ id: 'Numero_Identificacion_Representante_Legal', name: 'Identificación Rl' },
		{ id: 'Nombre_Representante_Legal', name: 'Nombre Rl' },
		{ id: 'Correo_Electronico', name: 'Correo Electrónico 1' },
		{ id: 'Correo_Electronico_Reportado', name: 'Correo Electrónico 2' },
		{ id: 'Telefono_Reportado_1', name: 'Teléfono 1' },
		{ id: 'Telefono_Reportado_2', name: 'Teléfono 2' },
		{ id: 'Patrimonio_Neto', name: 'Patrimonio Neto' },
	];

	constructor(private formBuilder: FormBuilder, private reportesPrestadoresService: ReportesPrestadoresService,
		private establecimientoComercioService: EstablecimientoComercioService, public authService: AuthService,
	) {
		this.createPagingTable();
		this.createForm();

		const selectAllControl = new FormControl(false);
		const formControl = this.exportarList.map(control => new FormControl(false));
		this.exportarForm = this.formBuilder.group({
			exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
			selectAll: selectAllControl
		});

		this.selectUsuario = null;
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.titleTable();
		this.onCamaraSelect();
		this.onChanges();
	}

	createForm() {
		this.filtro = this.formBuilder.group({
			codigo_camara: [null, Validators.compose([Validators.required])],
			activo: [null, Validators.compose([Validators.required])],
			usuario: [null, Validators.compose([Validators.required])],
			correo_electronico: [null, Validators.compose([Validators.required,
			ConfirmeValidators.emailValidator])],
			numero_identificacion: [null, Validators.compose([Validators.required])],
			razon_social: [null, Validators.compose([Validators.required])],
			numero_identificacion_representante_legal: [null, Validators.compose([Validators.required])],
			nombre_representante_legal: [null, Validators.compose([Validators.required])],
			patrimonio_neto: [null, Validators.compose([Validators.required])]
		});

		this.formCheck = this.formBuilder.group({
			orders: new FormArray([])
		});
	}

	createPagingTable() {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
	}

	onConsultarPrestador(page: number) {
		this.reportesPrestadoresService.getDataTable({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarPrestador(value);
	}

	filtrar() {
		this.paginaActual = 1;
		this.createPagingTable();
		this.onConsultarPrestador(1);
	}

	limpiar() {
		this.createPagingTable();
		this.filtro.reset();
		this.titleTable();
		this.onCamaraSelect();
		this.dataTabla.items = [];
	}

	titleTable() {
		this.headerTabla = ['Cámara de comercio', 'Nombre o Razón social', 'Nit', 'Departamento', 'Municipio',
			'Usuario', 'Activo', 'Identificación RL', 'Nombre RL', 'Correo electrónico 1', 'Correo electrónico 2', 'Teléfono 1',
			'Teléfono 2', 'Patrimonio neto'];
	}

	onCamaraSelect() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data;
			}
		});
	}

	onChanges() {
		this.exportarForm.get('selectAll').valueChanges.subscribe(bool => {
			this.exportarForm
				.get('exportarList')
				.patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
		});

		this.exportarForm.get('exportarList').valueChanges.subscribe(val => {
			const allSelected = val.every(bool => bool);
			if (this.exportarForm.get('selecAll').value !== allSelected) {
				this.exportarForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}

	minSelectCheckbox(min = 1) {
		const validator: ValidatorFn = (formArray: FormArray) => {
			const totalSelected = formArray.controls.map(control => control.value)
				.reduce((prev, next) => next ? prev + next : prev, 0);

			return totalSelected >= min ? null : { required: true };
		};
		return validator;
	}

	minFiltroCheck() {
		if (this.filtro.get('codigo_camara').valid || this.filtro.get('activo').valid
			|| this.filtro.get('usuario').valid || this.filtro.get('correo_electronico').valid
			|| this.filtro.get('numero_identificacion').valid || this.filtro.get('razon_social').valid
			|| this.filtro.get('numero_identificacion_representante_legal').valid || this.filtro.get('nombre_representante_legal').valid
			|| this.filtro.get('patrimonio_neto').valid) {
			return false;
		} else {
			return true;
		}
	}

	submit() {
		const selectedPreferences = this.exportarForm.value.exportarList
			.map((checked, index) => checked ? this.exportarList[index].id : null)
			.filter(value => value !== null);

		this.columnasEnvio = selectedPreferences.join();

		this.reportesPrestadoresService.generarExportarPrestadores({ ...this.filtro.value, columnas: this.columnasEnvio })
			.subscribe(resultado => {
				if (resultado.type === HttpEventType.Response) {
					if (resultado.ok) {
						this.saveAsExcelFile(resultado.body, `reporte_prestadores.xlsx`);
					}
				}
			});
	}

	private saveAsExcelFile(data: any, fileName: string): void {
		FileSaver.saveAs(data, fileName);
	}

}
